import React, { useState, useEffect } from 'react';
import { Button, Menu, MenuItem, CircularProgress } from '@material-ui/core';
import axios from "axios";
import envConfig from "../../../bin/env.config";

const CitySelector = ({ 
  selectedCity, 
  onCitySelect,
  project_id,
  token,
  style = {}
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchCities = async () => {
    try {
      setLoading(true);
      let putData = {
        project_id: project_id,
      }; 
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/project-cities`;
      const response = await axios.post(url, putData, {
        headers: {
          Authorization: JSON.stringify(token),
        },
      });
      
      // Filter cities based on project_id
      const filteredCities = response.data.data.filter(city => 
        city.company_report_tool_project_id === parseInt(project_id)
      );
      setCities(filteredCities);
    } catch (error) {
      console.error("Error fetching cities:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (project_id) {
      fetchCities();
    }
  }, [project_id]);

  const handleCityClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCityClose = () => {
    setAnchorEl(null);
  };

  const handleCitySelect = (city) => {
    onCitySelect(city);
    handleCityClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleCityClick}
        style={{ 
          minWidth: 200, 
          justifyContent: 'flex-start', 
          marginRight: '16px',
          ...style 
        }}
        disabled={loading}
      >
        {loading ? (
          <CircularProgress size={20} style={{ marginRight: 8 }} />
        ) : null}
        {selectedCity || 'All Cities'}
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCityClose}
      >
        <MenuItem onClick={() => handleCitySelect('')}>
          <em>All Cities</em>
        </MenuItem>
        {cities.map((city) => (
          <MenuItem key={city.id} onClick={() => handleCitySelect(city.city)}>
            {city.province} - {city.city}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default CitySelector; 